import { buildUserEmailPolicyActions } from '../../auth/UsersEmailsPolicyState';
import { mockActionsExpect } from '../helpers';
export default ((store, api, sharedActions) => {
  const originalActions = buildUserEmailPolicyActions(store, api, sharedActions);
  return mockActionsExpect(originalActions, ['setUserEmailPolicyState']);
});